import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Analytics from '@/utils/Analytics';
import { viewStats } from '@/utils/Analytics';
import { mapActions } from 'vuex';
import throttle from '@/utils/throttle';
import compareVersions from '@/utils/compareVersions';
import Cookie from 'drip/utils/cookie';
import axios from 'axios';
import KNB from 'KNB';
import Event from 'drip/event';
import Geo from 'drip/geo';
import Store from 'drip/store';
import Drip from 'drip';
import bottomTab from 'drip/components/bottom-tab';
import URL from 'drip/utils/url';
import SearchBar from '@/components/home/search-bar';
import TodayLook from '@/components/home/today-look';
import CategoryList from '@/components/home/CategoryList';
import ArtistList from '@/components/home/ArtistList';
import ArtistListNew from '@/components/home/ArtistListNew';
import RecommendList from '@/components/home/RecommendList';
import AdBanner from '@/components/home/AdBanner';
import WhatLook from '@/components/home/WhatLook';
import Top from '@/components/home/Top';
import SideIcon from '@/components/home/SideIcon';
import YellowStrip from '@/components/common/YellowStrip';
import PricePreSaleCard from '@/components/home/PricePreSaleCard';
import TicketGrabberStation from '@/components/home/TicketGrabberStation';
import PerformanceCalendar from '@/components/home/PerformanceCalendar';
import DailyCoupon from '@/components/home/DailyCoupon';
import DailyCouponNew from '@/components/home/DailyCouponNew';
import SkeletonScreen from '@/components/home/SkeletonScreen';
import { GET_YELLOW_STRIP } from '@/constants/home';
import { isProd } from '@/config';
import { fetchMaoyanADList, fetchShowRecommendList, fetchTodayList, fetchArtistList, fetchMyShowAds, fetchRecommendBrand, fetchSpecialOffer, fetchEarlyBird, fetchDailyCoupon, fetcPerformanceCalendarhDailyCoupon, fetchTicketStation } from '@/request/home';
import { getIsAbTest } from '@/request/abtest';
import cmblapi from '@myfe/cmblapi';
import { API_TOP_SHOWS_INFO, API_TOP_GROUP_PURCHASE_INFO, API_NEW_ARTISIT } from '@/apis';
var ACTIVITY_TAG = Drip.activityTag;
var MIDDLE_BANNER = 'MIDDLE_BANNER';
var TODAY_SALE = 'TODAY_SALE';
var GOLDEN_ICON = 'GOLDEN_ICON';
var ICON_SUBSCRIPT = 'ICON_SUBSCRIPT';
var WHAT_LOOK = 'WHAT_LOOK';
var STAR = 'STAR';
var SIDEBAR = 'SIDEBAR';
var RECOMMENDATION_1 = 'RECOMMENDATION_1';
var RECOMMENDATION_2 = 'RECOMMENDATION_2';
var RECOMMENDATION_3 = 'RECOMMENDATION_3';
var NEW_GOLDEN_ICON = 'NEW_GOLDEN_ICON';
var positionMap = {
  GOLDEN_ICON: 1219,
  // 金刚位
  ICON_SUBSCRIPT: 1230,
  // 金刚位角标
  TODAY_SALE: 1231,
  // 今日必抢
  MIDDLE_BANNER: 1221,
  // 中通位
  STAR: 1220,
  // 追星位
  WHAT_LOOK: 1262,
  // 榜单
  SIDEBAR: 1233,
  // 侧边栏
  RECOMMENDATION_1: 1232,
  // 推荐位1
  RECOMMENDATION_2: 1234,
  // 推荐位2
  RECOMMENDATION_3: 1235,
  // 推荐位3
  NEW_GOLDEN_ICON: 2441
};
var leftHeight = 0,
  rightHeight = 0;
export default {
  name: 'home-refactor',
  components: {
    SearchBar: SearchBar,
    CategoryList: CategoryList,
    TodayLook: TodayLook,
    AdBanner: AdBanner,
    ArtistList: ArtistList,
    ArtistListNew: ArtistListNew,
    WhatLook: WhatLook,
    RecommendList: RecommendList,
    SideIcon: SideIcon,
    YellowStrip: YellowStrip,
    Top: Top,
    PricePreSaleCard: PricePreSaleCard,
    TicketGrabberStation: TicketGrabberStation,
    PerformanceCalendar: PerformanceCalendar,
    DailyCoupon: DailyCoupon,
    DailyCouponNew: DailyCouponNew,
    SkeletonScreen: SkeletonScreen
  },
  data: function data() {
    var _window, _window$location;
    return {
      hasGood: false,
      goodObj: {},
      isMaoyanI: null,
      locCity: {},
      recommendTitle: Drip.UA.IS_GEWARA ? '精彩推荐' : '为你推荐',
      originPageScrollTop: 0,
      pageScrollTop: 0,
      // 金刚位
      goldenList: null,
      // 今日必抢推荐列表
      todayLookList: [],
      todayLookMap: {},
      specialPriceList: [],
      preSaleList: [],
      // 中通广告位列表
      adList: [],
      // 艺人大咖推荐列表
      artistList: [],
      recommendBrand: [],
      calcData: [],
      // 项目推荐列表
      recommendList: [],
      recommendIdList: [],
      // 投放 为你推荐
      // 侧边栏推荐列表
      sideList: [],
      // 推荐项目列表是否在加载中
      isLoading: false,
      // 是否有更多的推荐项目
      hasMore: false,
      // 推荐列表的当前页
      pageNo: 1,
      // 左项推荐列表
      recommendListLeft: [],
      // 右项推荐里列表
      recommendListRight: [],
      // 左项推荐列表默认颜色值
      DEFAULT_IMG_BG_LEFT_COLOR: ["#FFF2F1", "#FFFBF0", "#E9F6FF", "#F5F5F5", "#FFF1E6", "#ECF8F5", "#F6F1FF"],
      // 右项推荐列表默认颜色值
      DEFAULT_IMG_BG_RIGHT_COLOR: ["#FFF1E6", "#ECF8F5", "#F6F1FF", "#FFF2F1", "#FFFBF0", "#E9F6FF", "#F5F5F5"],
      isMSite: Boolean,
      // 是否m站
      isNewCustomHeader: true,
      IS_MEITUAN: false,
      IS_MAOYAN: false,
      IS_DIANPING: false,
      cityName: '',
      safeAreaPostion: {
        top: 58 // 如果native隐藏顶部导航栏，KNB方法没有成功返回，设置一个默认的安全高度
      },

      IS_ANDROID: true,
      groupPurchasePaging: {},
      ticketStationData: null,
      calendarModuleVO: null,
      dailyCouponDataNew: null,
      dailyCouponData: null,
      isHomeHideBack: /isHomeHideBack=true/.test((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href),
      // 美团，点评app 是否隐藏返回的按钮
      isShowSkeletonScreen: true,
      isAbTest: false,
      hasGetAbTestStatus: false,
      artMistiming: 0,
      artistListNew: []
    };
  },
  computed: {
    yellowStripInfo: function yellowStripInfo() {
      var _ref = this.$store.state.home || {},
        yellowStripInfo = _ref.yellowStripInfo;
      return yellowStripInfo;
    },
    hasArts: function hasArts() {
      var _this$artistListNew;
      return this.artistListNew && ((_this$artistListNew = this.artistListNew) === null || _this$artistListNew === void 0 ? void 0 : _this$artistListNew.length) > 3;
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var redirectUrl, url, isConsoleDebug, now, expires, istest, _now, _expires;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.IS_ANDROID = Drip.constant.uaInfo.osName === 'android';
            _this.setIsNewCustomHeader();
            KNB.subscribe({
              action: 'appear',
              handle: function handle() {
                var _Drip$UA;
                _this.getArtistList();
                if (Drip !== null && Drip !== void 0 && (_Drip$UA = Drip.UA) !== null && _Drip$UA !== void 0 && _Drip$UA.isNative) {
                  KNB === null || KNB === void 0 ? void 0 : KNB.getCity({
                    success: function success(res) {
                      var _Drip$constant;
                      var type = res.type,
                        cityId = res.cityId,
                        cityName = res.cityName,
                        locCityId = res.locCityId,
                        locCityName = res.locCityName;

                      // 兼容猫眼ios 只返回locCityId, locCityName
                      cityId = cityId || locCityId;
                      cityName = cityName || locCityName;
                      if (cityId !== (Drip === null || Drip === void 0 ? void 0 : (_Drip$constant = Drip.constant) === null || _Drip$constant === void 0 ? void 0 : _Drip$constant.cityId)) {
                        Geo === null || Geo === void 0 ? void 0 : Geo.setCity({
                          type: type,
                          cityId: cityId,
                          cityName: cityName
                        });
                      }
                    }
                  });
                }
              }
            });
            _this.isMaoyanI = _this.isMaoyanIFn();
            /** 招行定制 */
            if (!Drip.UA.IS_CMBAPP) {
              _context.next = 12;
              break;
            }
            //设置招行猫眼演出的首页
            try {
              cmblapi.applet({
                api: 'setHomepage',
                params: {
                  url: 'https://show.maoyan.com/qqw/'
                }
              });
            } catch (error) {}
            // r=redirectUrl，招行直接重定向到具体页面
            redirectUrl = URL.getQuery('r') || URL.getHashQuery('r');
            if (!redirectUrl) {
              _context.next = 12;
              break;
            }
            bottomTab.hide();
            url = decodeURIComponent(redirectUrl);
            location.replace(url);
            return _context.abrupt("return");
          case 12:
            if (_this.isMaoyanI) {
              bottomTab();
              bottomTab.show();
            }

            /** 线上debug console */
            isConsoleDebug = Cookie.get('_debugconsole');
            if (!isConsoleDebug && window.location.hash.indexOf('debugconsole=1') !== -1) {
              // 不存在 且以特定路径进入
              now = new Date().getTime();
              expires = now + 3600 * 3 * 1000;
              expires = new Date(expires);
              Cookie.set('_debugconsole', 'true', {
                path: '/',
                expires: expires.toGMTString()
              });
            }
            /** 线上debug coonsole */
            /** 压力测试专用 */
            istest = Cookie.get('_istest');
            if (!istest && window.location.hash.indexOf('test=1') !== -1) {
              // 不存在 且以特定路径进入
              _now = new Date().getTime();
              _expires = _now + 3600 * 3 * 1000;
              _expires = new Date(_expires);
              Cookie.set('_istest', 'true', {
                path: '/',
                expires: _expires.toGMTString()
              });
            }
            /** 压力测试专用 */
            // 清除运营位标志位
            _this.deleteActivityTag();
            _this.bottoming = throttle(_this.bottoming);
            _this.scroll = _this.throttle(_this.scroll, 300);
            window.addEventListener('scroll', _this.bottoming, false);
            window.addEventListener('scroll', _this.scroll, false);
            _this[GET_YELLOW_STRIP]();
            _this.isMSite = Drip.UA.IS_QQWALLET;
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.scroll, false);
    window.removeEventListener('scroll', this.bottoming, false);
    Event.off('cityChange', this.handleCityChange);
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    this.isMaoyanI && bottomTab.hide();
    next();
  },
  beforeCreate: function beforeCreate() {
    KNB.ready(function () {
      Geo.getCity();
      Geo.getLocCity();
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _Drip$UA2, _Drip$User;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if ((_Drip$UA2 = Drip.UA) !== null && _Drip$UA2 !== void 0 && _Drip$UA2.IS_SHENZHEN_ICBC && !((_Drip$User = Drip.User) !== null && _Drip$User !== void 0 && _Drip$User.isLogin)) {
              Drip.login({
                force: true
              }).then(function () {
                var _Drip$UA3;
                if ((_Drip$UA3 = Drip.UA) !== null && _Drip$UA3 !== void 0 && _Drip$UA3.isNative) {
                  var _window$location2;
                  (_window$location2 = window.location) === null || _window$location2 === void 0 ? void 0 : _window$location2.reload();
                }
              }).catch(function (err) {
                console.warn(err);
              });
            }

            // vue mounted 生命周期里 初始化打点
            _this2.initDataReport();

            // a=实验a版，b=实验b版
            getIsAbTest().then(function (res) {
              _this2.isAbTest = res;
              _this2.hasGetAbTestStatus = true;
              window.seedAction && window.seedAction({
                bid: 'b_movie_usyyk9ev_mv',
                evt: 'view',
                abtest: res ? '79b' : '79a'
              });
            }).catch(function (err) {
              console.warn(err);
            });
            _this2.init();
            Event.on('cityChange', _this2.handleCityChange);
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: Object.assign({}, mapActions([GET_YELLOW_STRIP]), {
    isMaoyanIFn: function isMaoyanIFn() {
      var _Drip$constant2, _Drip$constant2$uaInf;
      return ['qqwallet', 'maoyan_i', 'cmb_app', 'shenzhen_icbc'].includes((_Drip$constant2 = Drip.constant) === null || _Drip$constant2 === void 0 ? void 0 : (_Drip$constant2$uaInf = _Drip$constant2.uaInfo) === null || _Drip$constant2$uaInf === void 0 ? void 0 : _Drip$constant2$uaInf.appName);
    },
    bottoming: function bottoming() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var page, data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              page = _this3.$refs.homepage;
              if (!(!_this3.isLoading && _this3.hasMore && Number(window.scrollY) + Number(window.innerHeight) >= Number(page.clientHeight) - 50)) {
                _context3.next = 9;
                break;
              }
              // 触底, 有更多且不在加载中, 加载下一页
              _this3.isLoading = true;
              if (!_this3.groupPurchasePaging.hasMore) {
                _context3.next = 8;
                break;
              }
              _context3.next = 6;
              return _this3.getGroupPurchase(_this3.groupPurchasePaging.pageNo + 1);
            case 6:
              data = _context3.sent;
              _this3.groupPurchase = _this3.groupPurchase.concat(data);
            case 8:
              _this3.getRecommendList(_this3.pageNo + 1);
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 监听页面滚动事件
    scroll: function scroll() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var scrollTop, clientHeight, page, data;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              scrollTop = document.documentElement.scrollTop || document.body.scrollTop; // 窗口可视范围高度
              clientHeight = window.innerHeight || Math.min(document.documentElement.clientHeight, document.body.clientHeight);
              page = _this4.$refs.homepage; // 滑动至 3倍 clientHeight + 触底判断
              if (!(Math.round(scrollTop / clientHeight) >= _this4.pageNo * 3 && _this4.hasMore)) {
                _context4.next = 13;
                break;
              }
              if (!_this4.isLoading) {
                _context4.next = 6;
                break;
              }
              return _context4.abrupt("return");
            case 6:
              _this4.isLoading = true;
              if (!_this4.groupPurchasePaging.hasMore) {
                _context4.next = 12;
                break;
              }
              _context4.next = 10;
              return _this4.getGroupPurchase(_this4.groupPurchasePaging.pageNo + 1);
            case 10:
              data = _context4.sent;
              _this4.groupPurchase = _this4.groupPurchase.concat(data);
            case 12:
              _this4.getRecommendList(_this4.pageNo + 1);
            case 13:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 截流
    throttle: function throttle(fn, gapTime) {
      if (gapTime === null || gapTime === undefined) {
        gapTime = 1500;
      }
      var _lastTime = null;
      return function () {
        var _nowTime = +new Date();
        if (_nowTime - _lastTime > gapTime || !_lastTime) {
          _lastTime = _nowTime;
          fn.apply(this, arguments); // 将this和参数传给原函数
        }
      };
    },

    init: function init() {
      this.getPositionList();
    },
    // 初始化页面打点
    initDataReport: function initDataReport() {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var mtHistoryObj;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              mtHistoryObj = {
                'pt_channel_pv_second': '1737765286931263579'
              };
              Analytics('c_movie_aq5xt2v5', Drip.User.userId, {}, undefined, true, mtHistoryObj);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    handleCityChange: function handleCityChange(city) {
      var _this5 = this;
      setTimeout(function () {
        _this5.init();
      }, 500);
    },
    // 清除运营位标志位
    deleteActivityTag: function deleteActivityTag() {
      var utm = {};
      var oldUtmCookie = Cookie.get('_lx_utm');
      if (oldUtmCookie) {
        utm = URL.parseQuery(oldUtmCookie);
        Object.keys(utm).forEach(function (key) {
          if (key === ACTIVITY_TAG.STATS_TAG) {
            delete utm[key];
          }
        });
      }
      if (window.resetUTMAction) {
        window.resetUTMAction(utm);
      }
    },
    touchStart: function touchStart() {
      this.originPageScrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    },
    touchMove: function touchMove() {
      this.pageScrollTop = document.body.scrollTop || document.documentElement.scrollTop;
    },
    // 项目去重
    projectUnion: function projectUnion(list) {
      list = list || [];
      var idList = [];
      return list.filter(function (a) {
        var performanceId = a.performanceId;
        if (performanceId) {
          var hasFlag = idList.includes(performanceId);
          idList.push(performanceId);
          return !hasFlag;
        }
        return true;
      });
    },
    // 设置默认的海报图
    defaultPoster: function defaultPoster(list) {
      var poster = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
      return list.map(function (a) {
        a.posterUrl = a.posterUrl || poster;
        return a;
      });
    },
    // 跳转今日必抢页面
    gotoTodayPage: function gotoTodayPage() {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_fshak929_mc',
        abtest: 1,
        needTag: true
      });
      this.go('/today?categoryId=0');
    },
    // 获取今日必抢的列表
    getTodayList: function getTodayList() {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var data, listMap, i, filterProjectIds;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return fetchTodayList();
            case 2:
              data = _context6.sent;
              listMap = {};
              if (data && data.length > 0) {
                _context6.next = 6;
                break;
              }
              return _context6.abrupt("return", []);
            case 6:
              i = 0; // 今日必抢的打点数据
              data.forEach(function (a, index) {
                // 设置默认的海报图
                a.posterUrl = a.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
                a.hasScore = a.score && a.score !== '0.0' && a.score !== '0';
                if (a) {
                  a.dataSeed = {
                    bid: 'b_movie_41c8nv4n_mc',
                    viewBid: 'b_movie_41c8nv4n_mv',
                    performance_id: a.performanceId,
                    index: index,
                    abtest: 1
                  };
                  if (a.reachRobStandard) {
                    listMap[a.performanceId] = a;
                  } else {
                    if (i < 12) {
                      listMap[a.performanceId] = a;
                      i++;
                    }
                  }
                }
              });
              _this6.todayLookList = data;
              _this6.todayLookMap = listMap;
              filterProjectIds = data.map(function (item) {
                return item.performanceId;
              });
              return _context6.abrupt("return", filterProjectIds);
            case 12:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    // 首页抢票播报站和天天神券
    getTicketStationdailyCouponData: function getTicketStationdailyCouponData() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var resList, performanceId;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return Promise.all([fetchTicketStation(), fetchDailyCoupon()]);
            case 3:
              resList = _context7.sent;
              resList.forEach(function (res, index) {
                var isTicketStation = index === 0;
                var success = res.success,
                  data = res.data,
                  error = res.error;
                if (!success) {
                  return;
                }
                if (isTicketStation) {
                  _this7.ticketStationData = data;
                } else {
                  _this7.dailyCouponData = data;
                }
              });

              // 没有数据，直接返回
              if (!(!_this7.ticketStationData || !_this7.dailyCouponData)) {
                _context7.next = 7;
                break;
              }
              return _context7.abrupt("return");
            case 7:
              performanceId = _this7.ticketStationData.performanceId;
              _this7.ticketStationData.tagSeed = {
                performance_id: performanceId
              };
              _this7.ticketStationData.dataSeed = {
                bid: 'b_movie_coszs57c_mc',
                viewBid: 'b_movie_uqfi8tkv_mv',
                performance_id: performanceId,
                custom: {
                  performance_id: performanceId
                }
              };
              _this7.dailyCouponData.dailyCouponGroupProjects.forEach(function (item) {
                var performanceId = item.projectId;
                item.tagSeed = {
                  performance_id: performanceId
                };
                item.dataSeed = {
                  bid: 'b_movie_e4gfkopp_mc',
                  viewBid: 'b_movie_e4gfkopp_mv',
                  performance_id: performanceId,
                  custom: {
                    performance_id: performanceId
                  }
                };
              });
              _context7.next = 16;
              break;
            case 13:
              _context7.prev = 13;
              _context7.t0 = _context7["catch"](0);
              _this7.$owlReportError('演出首页-抢票播报站和天天神券-接口处理错误', _context7.t0);
            case 16:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 13]]);
      }))();
    },
    // 首页演出日历和天天神券 新版
    getPerformanceCalendarDailyCouponData: function getPerformanceCalendarDailyCouponData() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var res, success, data, error, attrMaps;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return fetcPerformanceCalendarhDailyCoupon();
            case 3:
              res = _context8.sent;
              success = res.success, data = res.data, error = res.error, attrMaps = res.attrMaps;
              if (success) {
                _context8.next = 7;
                break;
              }
              return _context8.abrupt("return");
            case 7:
              _this8.calendarModuleVO = data === null || data === void 0 ? void 0 : data.calendarModuleVO;
              if (_this8.calendarModuleVO) {
                _this8.calendarModuleVO.calendarNumber = attrMaps === null || attrMaps === void 0 ? void 0 : attrMaps.serverTime;
              }
              _this8.dailyCouponDataNew = data === null || data === void 0 ? void 0 : data.dailyCouponGroupVO;

              // 没有数据，直接返回
              if (!(!_this8.calendarModuleVO || !_this8.dailyCouponDataNew)) {
                _context8.next = 12;
                break;
              }
              return _context8.abrupt("return");
            case 12:
              _context8.next = 17;
              break;
            case 14:
              _context8.prev = 14;
              _context8.t0 = _context8["catch"](0);
              _this8.$owlReportError('演出首页-演出日历和天天神券-接口处理错误', _context8.t0);
            case 17:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[0, 14]]);
      }))();
    },
    // 获取临演列表、早鸟列表
    getEarlyBirdAndSpecialOfferList: function getEarlyBirdAndSpecialOfferList() {
      var _arguments = arguments,
        _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var filterProjectIds, resList;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              filterProjectIds = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : [];
              _context9.prev = 1;
              _context9.next = 4;
              return Promise.all([fetchSpecialOffer(filterProjectIds), fetchEarlyBird()]);
            case 4:
              resList = _context9.sent;
              resList.forEach(function (res, index) {
                var code = res.code,
                  data = res.data;
                if (code !== 200 || !data) {
                  return;
                }
                data.forEach(function (a, index) {
                  // 设置默认的海报图
                  a.posterUrl = a.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
                  a.dataSeed = {
                    bid: 'b_movie_hgsz1xj6_mc',
                    viewBid: 'b_movie_hgsz1xj6_mv',
                    performance_id: a.performanceId,
                    abtest: 1,
                    index: index
                  };
                });
                if (index === 0) {
                  _this9.specialPriceList = data;
                } else {
                  _this9.preSaleList = data;
                }
              });
              _context9.next = 11;
              break;
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](1);
              _this9.$owlReportError('演出首页-获取临演列表、早鸟列表-', _context9.t0);
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[1, 8]]);
      }))();
    },
    // 获取推荐的项目列表
    getRecommendList: function getRecommendList(pageNo) {
      var _arguments2 = arguments,
        _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var pageSize, _yield$fetchShowRecom, code, data, paging, _this10$brandPosition, calcData, recommendListLeft, recommendListRight, recommendListLeftTemp, recommendListRightTemp, dataTemp, index, _dataTemp, _dataTemp$index, _dataTemp2, _dataTemp2$index, hasMore;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              pageSize = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : 20;
              // 加载更多的打点数据
              window.seedAction({
                bid: 'b_movie_sw5v0dfh_mc'
              });
              _context10.next = 4;
              return fetchShowRecommendList(pageNo, pageSize);
            case 4:
              _yield$fetchShowRecom = _context10.sent;
              code = _yield$fetchShowRecom.code;
              data = _yield$fetchShowRecom.data;
              paging = _yield$fetchShowRecom.paging;
              if (!(code !== 200)) {
                _context10.next = 10;
                break;
              }
              return _context10.abrupt("return");
            case 10:
              data = data || [];
              data.forEach(function (a) {
                a.jumpUrl = "/myshow/#/detail/".concat(a.performanceId);
              });
              _this10$brandPosition = _this10.brandPositionCalc(data), calcData = _this10$brandPosition.calcData;
              data = calcData;
              recommendListLeft = _this10.recommendListLeft, recommendListRight = _this10.recommendListRight;
              recommendListLeftTemp = recommendListLeft || [];
              recommendListRightTemp = recommendListRight || [];
              if (!(pageNo !== 1)) {
                _context10.next = 47;
                break;
              }
              dataTemp = _this10.projectUnion(data); // 列表去重
              dataTemp = dataTemp.filter(function (a) {
                return !_this10.recommendIdList.includes("".concat(a.performanceId));
              });
              // 设置默认海报图
              dataTemp = _this10.defaultPoster(dataTemp);
              index = 0;
            case 22:
              if (!(index < dataTemp.length)) {
                _context10.next = 47;
                break;
              }
              try {
                // 打点
                if (!dataTemp[index].dataSeed) {
                  // 项目的打点
                  dataTemp[index].dataSeed = {
                    bid: 'b_movie_lrqkce7a_mc',
                    viewBid: 'b_movie_lrqkce7a_mv',
                    type: (_dataTemp = dataTemp) !== null && _dataTemp !== void 0 && (_dataTemp$index = _dataTemp[index]) !== null && _dataTemp$index !== void 0 && _dataTemp$index.discountTag ? 1 : 0,
                    index: index,
                    performance_id: (_dataTemp2 = dataTemp) === null || _dataTemp2 === void 0 ? void 0 : (_dataTemp2$index = _dataTemp2[index]) === null || _dataTemp2$index === void 0 ? void 0 : _dataTemp2$index.performanceId
                  };
                }
              } catch (e) {}
              if (!(index === Math.round((dataTemp.length - 1) / 2))) {
                _context10.next = 30;
                break;
              }
              _context10.next = 27;
              return _this10.getBoxHeight(recommendListLeftTemp, recommendListRightTemp);
            case 27:
              leftHeight <= rightHeight ? recommendListLeftTemp.push(dataTemp[index]) : recommendListRightTemp.push(dataTemp[index]);
              _context10.next = 44;
              break;
            case 30:
              if (!(index !== dataTemp.length - 1 && index % 2 === 0)) {
                _context10.next = 34;
                break;
              }
              recommendListLeftTemp.push(dataTemp[index]);
              _context10.next = 44;
              break;
            case 34:
              if (!(index !== dataTemp.length - 1 && index % 2 === 1)) {
                _context10.next = 38;
                break;
              }
              recommendListRightTemp.push(dataTemp[index]);
              _context10.next = 44;
              break;
            case 38:
              if (!(index === dataTemp.length - 1)) {
                _context10.next = 44;
                break;
              }
              // 在最后一项判断，左右列表高度，选择添加进哪边
              hasMore = paging.hasMore;
              if (hasMore) {
                _context10.next = 44;
                break;
              }
              _context10.next = 43;
              return _this10.getBoxHeight(recommendListLeftTemp, recommendListRightTemp);
            case 43:
              leftHeight <= rightHeight ? recommendListLeftTemp.push(dataTemp[index]) : recommendListRightTemp.push(dataTemp[index]);
            case 44:
              index++;
              _context10.next = 22;
              break;
            case 47:
              // this.recommendList = recommendList
              _this10.recommendListLeft = recommendListLeftTemp;
              _this10.recommendListRight = recommendListRightTemp;
              _this10.isLoading = false;
              if (paging) {
                _this10.pageNo = paging.pageNo;
                _this10.hasMore = paging.hasMore;
              }
            case 51:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    // 获取艺人列表
    getArtistList: function getArtistList() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var data;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return fetchArtistList();
            case 2:
              data = _context11.sent;
              _this11.artistList = data.filter(function (a) {
                return !!a;
              }).map(function (a, index) {
                a.mainImg = a.headUrl || 'https://p0.meituan.net/scarlett/2b130486b1c209d988544b9a5cc454ff4719.png';
                a.jumpUrl = "/artist?ipId=".concat(a.id);
                a.rightTopTitle = a.updateType > 0 ? 'NEW' : '';
                a.mainTitle = a.celebrityName || '';
                a.leftBottomTitle = a.concern;
                a.dataSeed = {
                  bid: 'b_movie_g14eeccl_mc',
                  viewBid: 'b_movie_g14eeccl_mv',
                  celebrity_id: a.celebrityId,
                  index: index
                };
                return a;
              });
            case 4:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    getMis: function getMis(serverTime) {
      // 获取延时
      var ms = new Date() - serverTime;
      return ms;
    },
    // 获取艺人列表 实验b版
    getArtistListNew: function getArtistListNew() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var uuid, osName, params, _yield$axios$get, attrMaps, _yield$axios$get$data, data, success, arr;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return Drip.getUuid();
            case 3:
              uuid = _context12.sent;
              osName = Drip.UA.osName;
              params = {
                uuid: uuid,
                clientType: osName === 'ios' ? 1 : 4,
                os: osName === 'ios' ? 1 : 2
              };
              _context12.next = 8;
              return axios.get("".concat(API_NEW_ARTISIT), {
                params: params
              });
            case 8:
              _yield$axios$get = _context12.sent;
              attrMaps = _yield$axios$get.attrMaps;
              _yield$axios$get$data = _yield$axios$get.data;
              data = _yield$axios$get$data === void 0 ? {} : _yield$axios$get$data;
              success = _yield$axios$get.success;
              if (success) {
                if (attrMaps && attrMaps.serverTime) {
                  _this12.artMistiming = _this12.getMis(attrMaps.serverTime);
                }
                arr = data && data.celebrityVoList || [];
                _this12.artistListNew = arr.filter(function (a) {
                  return !!a;
                }).map(function (a, index) {
                  var _a$tourInfoVo, _a$tourInfoVo$tourGro;
                  a.mainImg = a.headUrl || 'https://p0.meituan.net/scarlett/2b130486b1c209d988544b9a5cc454ff4719.png';
                  a.jumpUrl = "/artist?ipId=".concat(a.ipId);
                  a.rightTopTitle = a.updateType > 0 ? 'NEW' : '';
                  a.mainTitle = a.celebrityName || '';
                  a.leftBottomTitle = a.concern;
                  a.dataSeed = {
                    bid: 'b_movie_eundh7k9_mc',
                    viewBid: 'b_movie_eundh7k9_mv',
                    celebrity_id: a.celebrityId,
                    index: index,
                    category_id: '1'
                  };
                  a.tourInfoVo.tourGroupProjectVoList = (_a$tourInfoVo = a.tourInfoVo) === null || _a$tourInfoVo === void 0 ? void 0 : (_a$tourInfoVo$tourGro = _a$tourInfoVo.tourGroupProjectVoList) === null || _a$tourInfoVo$tourGro === void 0 ? void 0 : _a$tourInfoVo$tourGro.map(function (item) {
                    return Object.assign({}, item, {
                      dataSeed: {
                        bid: 'b_movie_34r244u4_mc',
                        viewBid: 'b_movie_34r244u4_mv',
                        index: index,
                        performance_id: item.performanceId,
                        category_id: '1',
                        needTag: true
                      }
                    });
                  });
                  return a;
                });
              }
              _context12.next = 20;
              break;
            case 16:
              _context12.prev = 16;
              _context12.t0 = _context12["catch"](0);
              _this12.$owlReportError('演出首页-新版艺人大咖-', _context12.t0);
              return _context12.abrupt("return", {});
            case 20:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[0, 16]]);
      }))();
    },
    // 获取榜单信息
    getGoodInfo: function getGoodInfo() {
      var _this13 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var _yield$_this13$$http$, data, code, msg, obj;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return _this13.$http.get(API_TOP_SHOWS_INFO);
            case 3:
              _yield$_this13$$http$ = _context13.sent;
              data = _yield$_this13$$http$.data;
              code = _yield$_this13$$http$.code;
              msg = _yield$_this13$$http$.msg;
              if (!(code !== 200)) {
                _context13.next = 9;
                break;
              }
              return _context13.abrupt("return", {});
            case 9:
              if (!(data && data.length > 0)) {
                _context13.next = 12;
                break;
              }
              obj = {
                'good': data.find(function (item) {
                  return item.billBoardAttrType === 1;
                }),
                'hot': data.find(function (item) {
                  return item.billBoardAttrType === 3;
                })
              };
              return _context13.abrupt("return", obj);
            case 12:
              return _context13.abrupt("return", {});
            case 15:
              _context13.prev = 15;
              _context13.t0 = _context13["catch"](0);
              _this13.$owlReportError('演出首页-榜单信息-', _context13.t0);
              return _context13.abrupt("return", {});
            case 19:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[0, 15]]);
      }))();
    },
    getRecommendBrand: function getRecommendBrand() {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        var data;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              _context14.next = 3;
              return fetchRecommendBrand();
            case 3:
              data = _context14.sent;
              return _context14.abrupt("return", data.filter(function (item) {
                return item.showUrls.length >= 3;
              }).map(function (item, index) {
                var brandIndex = 7 + index * 5;
                var dataSeed = {
                  bid: 'b_movie_grj7hfba_mc',
                  viewBid: 'b_movie_grj7hfba_mv',
                  index: brandIndex,
                  brand_id: item.id
                };
                var showUrls = item.showUrls.map(function (item) {
                  return item || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
                });
                return Object.assign({}, item, {
                  dataSeed: dataSeed,
                  showUrls: showUrls
                });
              }));
            case 7:
              _context14.prev = 7;
              _context14.t0 = _context14["catch"](0);
              _this14.$owlReportError('演出首页-推荐品牌官-', _context14.t0);
              return _context14.abrupt("return", []);
            case 11:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[0, 7]]);
      }))();
    },
    /**
    * 获取团购信息
    */
    getGroupPurchase: function getGroupPurchase(pageNo) {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        var _yield$_this15$$http$, data, code, msg, paging;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return _this15.$http.get(API_TOP_GROUP_PURCHASE_INFO, {
                params: {
                  pageNo: pageNo,
                  pageSize: 6
                }
              });
            case 3:
              _yield$_this15$$http$ = _context15.sent;
              data = _yield$_this15$$http$.data;
              code = _yield$_this15$$http$.code;
              msg = _yield$_this15$$http$.msg;
              paging = _yield$_this15$$http$.paging;
              if (!(code !== 200)) {
                _context15.next = 10;
                break;
              }
              return _context15.abrupt("return", []);
            case 10:
              _this15.groupPurchasePaging = paging || {};
              if (!(data && data.length > 0)) {
                _context15.next = 13;
                break;
              }
              return _context15.abrupt("return", data);
            case 13:
              return _context15.abrupt("return", []);
            case 16:
              _context15.prev = 16;
              _context15.t0 = _context15["catch"](0);
              _this15.$owlReportError('演出首页-团购信息-', _context15.t0);
              return _context15.abrupt("return", []);
            case 20:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 16]]);
      }))();
    },
    getBoxHeight: function getBoxHeight(recommendListLeft, recommendListRight) {
      var _this16 = this;
      return new Promise(function (resolve, reject) {
        _this16.recommendListLeft = recommendListLeft;
        _this16.recommendListRight = recommendListRight;
        // DOM 还没有更新
        _this16.$nextTick(function () {
          // DOM 现在更新了
          // `this` 绑定到当前实例
          leftHeight = this.$el.querySelector('#left') && this.$el.querySelector('#left').getBoundingClientRect().height;
          rightHeight = this.$el.querySelector('#right') && this.$el.querySelector('#right').getBoundingClientRect().height;
          resolve();
        });
      });
    },
    getGoldenList: function getGoldenList(arr) {
      var idSet = [];
      return arr.filter(function (_ref2) {
        var categoryId = _ref2.categoryId,
          labelId = _ref2.labelId,
          _isAbTest = _ref2._isAbTest;
        if (_isAbTest) return true;
        var idKey = "categoryId=".concat(categoryId, "&labelId=").concat(labelId);
        if (idSet.includes(idKey)) {
          return false;
        }
        idSet.push(idKey);
        return true;
      }).map(function (a, index) {
        var categoryId = a.categoryId,
          labelId = a.labelId,
          _isAbTest = a._isAbTest,
          positonType = a.positonType,
          mainContent = a.mainContent;
        var jumpUrl = "/list/".concat(categoryId, "?labelId=").concat(labelId || 0);
        a.jumpUrl = jumpUrl;
        a.mainTitle = a.positionName;
        if (_isAbTest) {
          // positonType:1项目2活动3小程序原生

          if (Number(positonType) === 1) a.jumpUrl = "/detail/".concat(mainContent);
          if (Number(positonType) === 2) a.jumpUrl = mainContent;
        }
        a.dataSeed = {
          bid: a._isAbTest ? 'b_movie_5hyac3rx_mc' : 'b_movie_mh9j6ixg_mc',
          viewBid: a._isAbTest ? 'b_movie_5hyac3rx_mv' : 'b_movie_mh9j6ixg_mv',
          category_id: categoryId,
          index: index
        };
        return a;
      });
    },
    sortGoldenList: function sortGoldenList(goldenList, _goldenList) {
      var allInfo = {
        mainTitle: '全部',
        mainImg: 'https://obj.pipi.cn/festatic/common/image/c4ddd841d8c7f43dcd29c80e4038254c.png',
        jumpUrl: "/list/0?labelId=0",
        dataSeed: {
          bid: 'b_movie_mh9j6ixg_mc',
          viewBid: 'b_movie_mh9j6ixg_mv',
          category_id: 0,
          index: goldenList.length,
          needTag: true
        }
      };
      var leftGoldenList = goldenList.slice(0, 10);
      var leftMidIndex = Math.ceil(leftGoldenList.length / 2);
      var leftIndex = 0;
      while (leftIndex < leftMidIndex) {
        _goldenList.push([leftGoldenList[leftIndex], leftGoldenList[leftIndex + leftMidIndex] || allInfo]);
        leftIndex++;
      }
      var rightGoldenList = goldenList.slice(10);
      if (rightGoldenList.length > 0) {
        var rightMidIndex = Math.ceil(rightGoldenList.length / 2);
        var rightIndex = 0;
        while (rightIndex < rightMidIndex) {
          _goldenList.push([rightGoldenList[rightIndex], rightGoldenList[rightIndex + rightMidIndex] || allInfo]);
          rightIndex++;
        }
      }
    },
    // 获取资源位列表
    getPositionList: function getPositionList() {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var _Drip$UA4, _Drip$UA5;
        var filterProjectIds, totalList, goldenItem, newGoldenItem, goldenList, _adVOList, iconSubscriptItem, list, _goldenList, bannerItem, adList, adVOList, maoyanAd, _Drip$constant3, ad, sideItem, recommendIdList, positionAdMap, recommendAds, projectList, _ref4, data, code, paging, attrMaps, itemCount, item3, resouce, item2, _resouce, item1, _resouce2, _this17$brandPosition, calcData, recommendList, recommendListLeft, recommendListRight, index, _recommendList$index, _recommendList$index2, _recommendList$index3;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _this17.isShowSkeletonScreen = true;
              _this17.calcData = [];

              // 获取首页演出日历和天天神券
              _this17.getPerformanceCalendarDailyCouponData();
              _this17.getArtistListNew();

              // 获取首页抢票播报站和天天神券
              _this17.getTicketStationdailyCouponData();
              if (!((_Drip$UA4 = Drip.UA) !== null && _Drip$UA4 !== void 0 && _Drip$UA4.IS_CMBAPP) && !((_Drip$UA5 = Drip.UA) !== null && _Drip$UA5 !== void 0 && _Drip$UA5.IS_SHENZHEN_ICBC)) {
                // 获取艺人大咖
                _this17.getArtistList();
              }
              // 今日必抢
              _context16.next = 8;
              return _this17.getTodayList();
            case 8:
              filterProjectIds = _context16.sent;
              // 获取临演和早鸟
              _this17.getEarlyBirdAndSpecialOfferList(filterProjectIds);
              _context16.next = 12;
              return Promise.all([fetchMyShowAds(), fetchMaoyanADList(), fetchShowRecommendList(1, 20), _this17.getRecommendBrand(), _this17.getGoodInfo(), _this17.getGroupPurchase(1)]);
            case 12:
              totalList = _context16.sent;
              _this17.recommendBrand = totalList[3];
              _this17.goodObj = totalList[4];
              _this17.groupPurchase = totalList[5];
              _this17.isShowSkeletonScreen = false;
              setTimeout(function () {
                viewStats({
                  target: {}
                });
              }, 1000);
              // 金刚位的处理
              goldenItem = totalList[0] && (totalList[0].goldenAds || []).find(function (a) {
                return a.positionId === positionMap[GOLDEN_ICON];
              });
              newGoldenItem = totalList[0] && (totalList[0].goldenAds || []).find(function (a) {
                return a.positionId === positionMap[NEW_GOLDEN_ICON];
              });
              goldenList = [];
              if (goldenItem && newGoldenItem) {
                _adVOList = _toConsumableArray(goldenItem.adVOList);
                newGoldenItem.adVOList.forEach(function (t) {
                  return t._isAbTest = true;
                });
                _adVOList.splice.apply(_adVOList, [8, 0].concat(_toConsumableArray(newGoldenItem.adVOList)));
                goldenList = _this17.getGoldenList(_adVOList);
              }

              // 金刚位角标的处理
              iconSubscriptItem = totalList[0] && (totalList[0].goldenAds || []).find(function (a) {
                return a.positionId === positionMap[ICON_SUBSCRIPT];
              });
              if (iconSubscriptItem) {
                list = iconSubscriptItem.adVOList.map(function (_ref3) {
                  var frame = _ref3.frame,
                    mainText = _ref3.mainText;
                  return {
                    frame: frame,
                    mainText: mainText
                  };
                });
                goldenList.forEach(function (a, i) {
                  var subIconitem = list[i];
                  if (subIconitem) {
                    a.rightTopTitle = subIconitem.mainText;
                  }
                });
              }
              _goldenList = [];
              _this17.sortGoldenList(goldenList, _goldenList);
              _this17.goldenList = _goldenList;

              // 中通位的处理
              bannerItem = totalList[0] && (totalList[0].middleBannerAds || []).find(function (a) {
                return a.positionId === positionMap[MIDDLE_BANNER];
              });
              if (bannerItem) {
                adList = [];
                adVOList = bannerItem.adVOList;
                adList = adVOList.map(function (a, index) {
                  var positonType = a.positonType,
                    mainContent = a.mainContent,
                    mainImg = a.mainImg;
                  var jumpUrl = '';
                  if (positonType === '2') {
                    // 活动
                    jumpUrl = mainContent;
                  } else if (positonType === '1') {
                    // 项目id
                    jumpUrl = "/myshow/#/detail/".concat(mainContent);
                  }
                  a.jumpUrl = jumpUrl;
                  // 中通的打点
                  a.dataSeed = {
                    bid: 'b_movie_db2gl1zk_mc',
                    viewBid: 'b_movie_db2gl1zk_mv',
                    index: index,
                    needTag: true
                  };
                  return a;
                });
                // 电影猫眼的广告位
                maoyanAd = totalList[1];
                if (maoyanAd && maoyanAd[0]) {
                  ad = maoyanAd[0];
                  ad.jumpUrl = ad.link;
                  ad.mainImg = ad.image.replace(/^(http:\/\/)/g, 'https://');
                  // 猫眼广告的打点
                  ad.dataSeed = {
                    cid: 'c_vwmiv52u',
                    bid: 'b_z3wg6f7b',
                    viewBid: 'b_8b99ppoq',
                    positionId: ad.positionId,
                    ad_id: ad.adId,
                    materialId: ad.materialId,
                    ci: (_Drip$constant3 = Drip.constant) === null || _Drip$constant3 === void 0 ? void 0 : _Drip$constant3.cityId
                  };
                  adList.unshift(ad);
                }
                _this17.adList = adList;
              }

              // 侧边栏的处理
              sideItem = totalList[0] && (totalList[0].middleBannerAds || []).find(function (a) {
                return a.positionId === positionMap[SIDEBAR];
              });
              if (sideItem) {
                _this17.sideList = sideItem.adVOList.map(function (a, index) {
                  var positonType = a.positonType,
                    mainContent = a.mainContent,
                    mainImg = a.mainImg;
                  var jumpUrl = '';
                  // 活动
                  if (positonType === '2') {
                    jumpUrl = mainContent;
                  } else if (positonType === '1') {
                    // 项目id
                    jumpUrl = "/myshow/#/detail/".concat(mainContent);
                  }
                  a.link = jumpUrl;
                  a.thumb = mainImg;
                  a.dataSeed = {
                    bid: 'b_movie_zqqyt5zx_mc',
                    viewBid: 'b_movie_zqqyt5zx_mv',
                    index: index
                  };
                  return a;
                });
              }
              // 根据项目id,获取项目详情
              recommendIdList = [];
              positionAdMap = {}; // 推荐位的处理
              recommendAds = totalList[0] && totalList[0].recommendAds || [];
              recommendAds.forEach(function (a) {
                positionAdMap[a.positionId] = a.adVOList.map(function (a) {
                  var positonType = a.positonType,
                    mainContent = a.mainContent,
                    mainImg = a.mainImg;
                  var jumpUrl = '';
                  // 活动
                  if (positonType === '2') {
                    jumpUrl = mainContent;
                    a.posterUrl = mainImg;
                  } else if (positonType === '1') {
                    recommendIdList.push(mainContent);
                    // 项目id
                    a.performanceId = mainContent;
                  }
                  a.jumpUrl = jumpUrl;
                  return a;
                });
              });
              // 获取项目详情列表
              if (recommendIdList.length > 0) {
                projectList = totalList[0] && totalList[0].recommendPerformances || [];
                Object.keys(positionAdMap).forEach(function (id) {
                  var adList = positionAdMap[id] || [];
                  adList = adList.map(function (ad) {
                    if (!ad.performanceId) return ad;
                    // 项目推荐
                    var projectDetail = projectList.find(function (a) {
                      return a.performanceId === +ad.performanceId;
                    });
                    if (projectDetail) {
                      projectDetail.positonType = ad.positonType;
                      return projectDetail;
                    }
                    // 项目下架
                    return null;
                  });
                  positionAdMap[id] = adList;
                });
              }
              _this17.recommendIdList = recommendIdList;
              _ref4 = totalList[2] || {}, data = _ref4.data, code = _ref4.code, paging = _ref4.paging, attrMaps = _ref4.attrMaps;
              data = data || [];
              itemCount = 0;
              if (data && data.length > 0) {
                // 推荐位和推荐列表的去重
                data = data.filter(function (a) {
                  return !recommendIdList.includes("".concat(a.performanceId));
                });
                // 推荐位3的替换
                item3 = positionAdMap[positionMap[RECOMMENDATION_3]];
                if (item3 && item3.length > 0) {
                  resouce = item3[0];
                  if (resouce) {
                    resouce.dataSeed = {
                      bid: 'b_movie_9g4yfmzc_mc',
                      viewBid: 'b_movie_9g4yfmzc_mv',
                      index: 2,
                      type: resouce.discountTag ? 1 : 0,
                      style: resouce.positonType === '1' ? 1 : 0,
                      performance_id: resouce.performanceId,
                      needTag: true
                    };
                  }
                  data.splice(3, 0, item3[0]);
                  itemCount += 1;
                }
                // 推荐位2的替换
                item2 = positionAdMap[positionMap[RECOMMENDATION_2]];
                if (item2 && item2.length > 0) {
                  _resouce = item2[0];
                  if (_resouce) {
                    _resouce.dataSeed = {
                      bid: 'b_movie_9g4yfmzc_mc',
                      viewBid: 'b_movie_9g4yfmzc_mv',
                      index: 1,
                      type: _resouce.discountTag ? 1 : 0,
                      style: _resouce.positonType === '1' ? 1 : 0,
                      performance_id: _resouce.performanceId,
                      needTag: true
                    };
                  }
                  data.splice(2, 0, item2[0]);
                  itemCount += 1;
                }

                // 推荐位1的替换
                item1 = positionAdMap[positionMap[RECOMMENDATION_1]];
                if (item1 && item1.length > 0) {
                  _resouce2 = item1[0];
                  if (_resouce2) {
                    _resouce2.dataSeed = {
                      bid: 'b_movie_9g4yfmzc_mc',
                      viewBid: 'b_movie_9g4yfmzc_mv',
                      index: 0,
                      type: _resouce2.discountTag ? 1 : 0,
                      style: _resouce2.positonType === '1' ? 1 : 0,
                      performance_id: _resouce2.performanceId,
                      needTag: true
                    };
                  }
                  data.splice(1, 0, item1[0]);
                  itemCount += 1;
                }
                // 过滤为空的数据
                data = data.filter(function (a) {
                  return !!a;
                });
              }
              _this17$brandPosition = _this17.brandPositionCalc(data, true, itemCount), calcData = _this17$brandPosition.calcData;
              data = calcData;
              recommendList = _this17.projectUnion(data); // 设置默认海报图
              recommendList = _this17.defaultPoster(recommendList);
              _this17.hasMore = paging && paging.hasMore;
              recommendListLeft = [];
              recommendListRight = [];
              _this17.isLoading = true;
              index = 0;
            case 50:
              if (!(index < recommendList.length)) {
                _context16.next = 66;
                break;
              }
              try {
                // 打点
                if (!((_recommendList$index = recommendList[index]) !== null && _recommendList$index !== void 0 && _recommendList$index.dataSeed)) {
                  // 项目的打点
                  recommendList[index].dataSeed = {
                    bid: 'b_movie_lrqkce7a_mc',
                    viewBid: 'b_movie_lrqkce7a_mv',
                    type: (_recommendList$index2 = recommendList[index]) !== null && _recommendList$index2 !== void 0 && _recommendList$index2.discountTag ? 1 : 0,
                    index: index,
                    performance_id: (_recommendList$index3 = recommendList[index]) === null || _recommendList$index3 === void 0 ? void 0 : _recommendList$index3.performanceId,
                    needTag: true
                  };
                }
              } catch (e) {}
              if (!(index !== recommendList.length - 1 && index % 2 === 0)) {
                _context16.next = 56;
                break;
              }
              recommendListLeft.push(recommendList[index]);
              _context16.next = 63;
              break;
            case 56:
              if (!(index !== recommendList.length - 1 && index % 2 === 1)) {
                _context16.next = 60;
                break;
              }
              recommendListRight.push(recommendList[index]);
              _context16.next = 63;
              break;
            case 60:
              _context16.next = 62;
              return _this17.getBoxHeight(recommendListLeft, recommendListRight);
            case 62:
              leftHeight <= rightHeight ? recommendListLeft.push(recommendList[index]) : recommendListRight.push(recommendList[index]);
            case 63:
              index++;
              _context16.next = 50;
              break;
            case 66:
              _this17.hasMore = paging && paging.hasMore;
              _this17.recommendListLeft = recommendListLeft;
              _this17.recommendListRight = recommendListRight;
              _this17.isLoading = false;
            // 暂时不考虑预加载效果
            // this.getRecommendList(2, 10) // 预加载第二屏
            case 70:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    brandPositionCalc: function brandPositionCalc(data, init, itemCount) {
      var newData = [];
      var newList2 = [];
      var newList3 = [];
      try {
        var list = this.recommendBrand,
          goodObj = this.goodObj,
          groupPurchase = this.groupPurchase;
        var goodDataSeed = {
          bid: 'b_movie_t2tnxgps_mc',
          viewBid: 'b_movie_t2tnxgps_mv',
          custom: {
            index: 14,
            custom: {
              tab_id: 1
            }
          }
        };
        var hotDataSeed = {
          bid: 'b_movie_t2tnxgps_mc',
          viewBid: 'b_movie_t2tnxgps_mv',
          custom: {
            index: 5,
            custom: {
              tab_id: 3
            }
          }
        };
        var hotObj = Object.assign({}, goodObj.hot, {
          isHot: true,
          dataSeed: hotDataSeed
        });
        var readObj = Object.assign({}, goodObj.good, {
          isGood: true,
          dataSeed: goodDataSeed
        });
        var brandList = JSON.parse(JSON.stringify(list));
        var groupPurchaseList = JSON.parse(JSON.stringify(groupPurchase));
        if (init) {
          this.calcData = [];
          brandList.forEach(function (item, index) {
            item.num = index * 5 + 7;
            item.index = index * 5 + 7;
            item.isBrand = true;
          });
          groupPurchaseList.forEach(function (item, index) {
            item.num = index * 5 + 8;
            item.index = index * 5 + 8;
            item.isGroupPurchase = true;
            item.cardIndex = index;
          });
          // 优先热度榜
          if (goodObj.hot && !goodObj.good) {
            data.splice(4, 0, hotObj);
          }
          if (!goodObj.hot && goodObj.good) {
            data.splice(4, 0, readObj);
          }
          if (goodObj.hot && goodObj.good) {
            data.splice(4, 0, hotObj);
            data.splice(13, 0, readObj);
          }

          // 如果推荐位为3并且有榜单，那么此时推荐位3被排到了第6，需要与第一个榜单（第五）后面的商品卡置换位置
          if (itemCount === 3 && Object.keys(goodObj).length) {
            var numSix = data.splice(5, 1)[0];
            data.splice(6, 0, numSix);
          }
        }
        var index1 = 0; // Index for data
        var index2 = 0; // Index for brandList
        var index3 = 0; // Index for groupPurchaseList

        var maxLength = data.length + brandList.length + groupPurchaseList.length + (this.calcData.length || 0);
        // console.log(data.length , brandList.length , groupPurchaseList.length)
        var currentIndex = this.calcData.length || 0; // Current index in newData
        while (currentIndex < maxLength) {
          if (currentIndex >= 2 && (currentIndex - 2) % 6 === 0 && index3 < groupPurchaseList.length) {
            // 插入 groupPurchaseList 的元素到第 9, 15, 21, ... 位置
            newData.push(Object.assign({}, groupPurchaseList[index3], {
              isGroupPurchase: true
            }));
            index3++;
          } else if (currentIndex >= 6 && (currentIndex - 6) % 5 === 0 && index2 < brandList.length) {
            // 插入 brandList 的元素到第 7, 12, 17, ... 位置
            newData.push(brandList[index2]);
            index2++;
          } else if (index1 < data.length) {
            // 插入 data 的元素
            newData.push(data[index1]);
            index1++;
          }
          if (index1 >= data.length) {
            break;
          }
          currentIndex++;
        }
        // 将剩余的 brandList 和 groupPurchaseList 的元素放入新列表中
        while (index2 < brandList.length) {
          newList2.push(brandList[index2]);
          index2++;
        }
        while (index3 < groupPurchaseList.length) {
          newList3.push(groupPurchaseList[index3]);
          index3++;
        }
        var newCalcData = [].concat(_toConsumableArray(this.calcData), newData);
        this.recommendBrand = newList2;
        this.groupPurchase = newList3;
        this.calcData = newCalcData;
        return {
          calcData: newData
        };
      } catch (e) {
        this.$owlReportError('演出首页-brandPositionCalc-', e);
        return {
          calcData: newData
        };
      }
    },
    handleSearchClick: function handleSearchClick() {
      window.seedAction({
        bid: 'b_movie_twpdo6ou_mc',
        needTag: true
      });
      var sellChannel = Drip.constant.appType;
      //  美大猫微M站 指向新搜索，微信小程序原生，单独处理 
      if ([1, 2, 3, 5, 13, 37].includes(sellChannel)) {
        var url = URL.getUrl('/myshowfe/trade/SearchByIndex', {
          _blank: true
        });
        Drip.redirect(url);
      } else {
        this.go('/search', {
          _blank: true
        });
      }
    },
    handleCityClick: function handleCityClick() {
      var _this18 = this;
      KNB.pickCity({
        type: 0,
        // 默认值0:国内城市, 1: 国际城市;
        needResult: 0,
        // 默认值 0：选择且切换城市，1：支持选择城市但不切换 App 城市
        success: function success(result) {
          var cityName = result.cityName,
            cityId = result.cityId;
          if (!cityId) return;
          _this18.cityName = cityName;
          Geo.setCity({
            cityId: cityId,
            cityName: cityName
          });
        }
      });
      window.seedAction({
        bid: 'b_movie_cwyw3css_mc'
      });
    },
    closeCurPage: function closeCurPage() {
      KNB.closePage({});
    },
    // 异常上报
    reportError: function reportError(name, error) {
      window.Owl && window.Owl.addError({
        name: name,
        msg: {
          error: error
        }
      });
    },
    setIsNewCustomHeader: function setIsNewCustomHeader() {
      var _this19 = this;
      var _Drip$constant4 = Drip.constant,
        _Drip$constant4$cityN = _Drip$constant4.cityName,
        cityName = _Drip$constant4$cityN === void 0 ? '' : _Drip$constant4$cityN,
        _Drip$constant4$uaInf = _Drip$constant4.uaInfo,
        IS_MEITUAN = _Drip$constant4$uaInf.IS_MEITUAN,
        IS_MAOYAN = _Drip$constant4$uaInf.IS_MAOYAN,
        IS_DIANPING = _Drip$constant4$uaInf.IS_DIANPING;
      this.cityName = cityName;
      if (IS_MAOYAN || IS_MEITUAN || IS_DIANPING) {
        // 猫眼新版本
        var MY_NEW_VERSION = compareVersions(Drip.UA.appVersion, '9.57.0');

        // 美团新版本
        var MEITUAN_NEW_VERSION = compareVersions(Drip.UA.appVersion, '12.22.200');

        // 点评新版本
        var DP_NEW_VERSION = compareVersions(Drip.UA.appVersion, '11.24.0');
        var NEW_VERSION = IS_MAOYAN ? MY_NEW_VERSION : IS_MEITUAN ? MEITUAN_NEW_VERSION : DP_NEW_VERSION;

        // 版本号 && 2个新增参数

        var urlHaveHideFlag = location.href.indexOf('notitlebar=1') > -1 && location.href.indexOf('future=2') > -1;
        if (NEW_VERSION && urlHaveHideFlag) {
          this.isNewCustomHeader = true;
        } else {
          this.isNewCustomHeader = false;
        }
      } else {
        this.isNewCustomHeader = false;
      }
      if (IS_DIANPING && this.isNewCustomHeader) {
        !this.IS_ANDROID && KNB.setNavButtons({
          position: 'LL',
          type: 'text',
          text: '   '
        });
      }
      if (this.isNewCustomHeader) {
        this.Env.setTitle('   ');
      } else {
        this.Env.setTitle('演出/玩乐');
      }
      this.IS_MEITUAN = IS_MEITUAN;
      this.IS_MAOYAN = IS_MAOYAN;
      this.IS_DIANPING = IS_DIANPING;
      KNB.use('getSafeArea', {
        success: function success(result) {
          if (IS_DIANPING && !_this19.IS_ANDROID) {
            var _Drip$UA6;
            // 点评app 演出页面作为tab页面，此时的安全高度获取的是准确的，不需要减去44
            var DP_SHOW_TAB_SUPPORT = _this19.isHomeHideBack && compareVersions((_Drip$UA6 = Drip.UA) === null || _Drip$UA6 === void 0 ? void 0 : _Drip$UA6.appVersion, '11.32.10');
            if (!DP_SHOW_TAB_SUPPORT) {
              _this19.safeAreaPostion.top = result.top - 44;
            } else {
              _this19.safeAreaPostion.top = result.top;
            }
          } else {
            _this19.safeAreaPostion.top = result.top;
          }
          if (_this19.isNewCustomHeader && result.top === 0) {
            // 如果native隐藏了顶部导航栏，但是KNB获取安全高度为0，将安全高度设置为58，
            _this19.safeAreaPostion.top = 58;
          }
        }
      });
    },
    changeTourSaleStatusNew: function changeTourSaleStatusNew(obj) {
      var artIndex = obj.artIndex,
        tourIndex = obj.tourIndex;
      var list = JSON.parse(JSON.stringify(this.artistListNew));

      // eslint-disable-next-line @myfe/myyc-rules/prefer-optional-chaining
      list[artIndex].tourInfoVo.tourGroupProjectVoList[tourIndex].saleStatus = 3;
      this.artistListNew = list;
    }
  })
};